import { LogOut, Menu, User, X } from 'lucide-react';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { navigationItems } from './Navigation';

export const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Change header background if DEVMODE is true
  const headerBg = process.env.REACT_APP_DEVMODE === 'true' ? 'bg-green-100' : 'bg-white';
  return (
    <header className={`${headerBg} shadow-sm border-b border-secondary-200 relative`}>
      <div className="px-4 md:px-6 h-[65px]">
        <div className="hidden md:flex h-full items-center justify-between">
          <div className="flex items-center space-x-4">
            <img
              src="/img/xreg-logo.png"
              srcSet="/img/xreg-logo.png 1x, /img/xreg-logo-high.png 2x"
              alt="XRegulation"
              className="h-full w-auto block"
            />
          </div>

          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-secondary-600">
              <User className="h-5 w-5" />
              <span className="text-sm font-medium">{user?.fullName || user?.email}</span>
            </div>

            <button
              onClick={logout}
              className="flex items-center space-x-2 text-secondary-500 hover:text-secondary-700 transition-colors"
            >
              <LogOut className="h-5 w-5" />
              <span className="text-sm">Logout</span>
            </button>
          </div>
        </div>

        <div className="flex md:hidden h-full items-center justify-between">
          <img
            src="/img/xreg-logo.png"
            srcSet="/img/xreg-logo.png 1x, /img/xreg-logo-high.png 2x"
            alt="XRegulation"
            className="h-full w-auto block"
          />
          <button
            type="button"
            aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            onClick={() => setIsMobileMenuOpen((previous) => !previous)}
            className="p-2 rounded-md border border-secondary-200 text-secondary-700 hover:bg-secondary-50"
          >
            {isMobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden absolute left-0 right-0 top-full bg-white border-b border-secondary-200 shadow-lg z-20">
          <div className="px-4 py-3 min-h-[240px] flex flex-col">
            <ul className="space-y-1">
              {navigationItems.map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.href}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center space-x-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isActive
                        ? 'bg-primary-50 text-primary-700'
                        : 'text-secondary-600 hover:bg-secondary-50 hover:text-secondary-900'}`
                    }
                  >
                    <item.icon className="h-5 w-5" />
                    <span>{item.name}</span>
                  </NavLink>
                </li>
              ))}
            </ul>

            <button
              type="button"
              onClick={() => {
                setIsMobileMenuOpen(false);
                logout();
              }}
              className="mt-auto flex items-center space-x-2 text-secondary-500 hover:text-secondary-700 transition-colors px-3 py-2"
            >
              <LogOut className="h-5 w-5" />
              <span className="text-sm">Logout</span>
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
